const colorTestKeywords: Record<number, string> = {
  0: "그림",
  1: "나는",
  2: "해",
  3: "마을",
  4: "감자",
  5: "남",
  6: "닭",
  7: "그래",
};

const colorTestResults: Record<number, number> = {
  0: 4,
  1: 6,
  2: 9,
  3: 5,
  4: 4,
  5: 2,
  6: 8,
  7: 3,
};

export const getColorTestKeyword = (pageNo: number) => {
  return colorTestKeywords[pageNo];
};

export const getColorTestResult = (pageNo: number) => {
  return colorTestResults[pageNo];
};

const colorTestContents: Record<number, string> = {
  0: '어린이였을 때의 레옹 베르뜨에게.\n여섯 살 적에 나는 "체험한 이야기"라는 제목의, 원시림에 관한 책에서 기막힌 그림 하나를 본 적이 있다.\n맹수를 집어삼키고 있는 보아 구렁이 그림이었다. 위의 그림은 그것을 옮겨 그린 것이다. 그 책에는 이렇게 씌어 있었다.\n"보아 구렁이는 먹이를 씹지도 않고 통째로 집어삼킨다. 그리고는 꼼짝도 하지 못하고 여섯 달 동안 잠을 자면서 그것을 소화시킨다."\n나는 그래서 밀림 속에서의 모험에 대해 한참 생각해 보고 난 끝에 색연필을 가지고 내 나름대로 내 생애 첫 번째 그림을 그려보았다.\n나의 그림 제 1호였다. 나는 그 걸작품을 어른들에게 보여 주면서 내 그림이 무섭지 않느냐고 물었다.\n그들은 "모자가 뭐가 무섭다는 거니?"하고 대답했다.\n내 그림은 모자를 그린 게 아니었다. 그것은 코끼리를 소화시키고 있는 보아 구렁이었다.',
  1: '어른들은 언제나 스스로는 아무것도 이해하지 못한다.\n자꾸자꾸 설명을 해주어야 하니 맥빠지는 노릇이 아닐 수 없다.\n그래서 다른 직업을 선택하지 않을 수 없게 된 나는 비행기 조종하는 법을 배웠다.\n세계의 여기저기 거의 안가본 데 없이 나는 날아다녔다.\n나는 그리하여 일생 동안 수없이 많은 점잖은 사람들과 수많은 접촉을 가져왔다. 어른들 틈에서 많이 살아온 것이다.\n 그렇다고 해서 그들에 대한 내 생각이 나아진 건 없었다.\n조금 총명해 보이는 사람을 만날 때면 나는 늘 간직해 오고 있던 예의 나의 그림 제 1호를 가지고 그 사람을 시험해 보고는 했다.\n그 사람이 정말로 뭘 이해할 줄 아는 사람인가 알고 싶었던 것이다.\n그러나 으레 그 사람은 "모자군"하고 대답하는 것이었다.\n 그러면 나는 보아 구렁이도 원시림도 별들도 그에게 이야기하지 않았다.',
  2: '"나는 해질 무렵을 좋아해. 해지는 걸 보러가..."\n"기다려야지..." "뭘 기다리지?" \n너는 처음에는 몹시 놀라는 기색이었으나 곧 자기 말이 우스운 듯 웃음을 터뜨렸지. 그리고는 나에게 말했지. \n"아직도 집에 있는 것만 같거든!" \n실제로 그럴 수도 있는 일이었다. 모두들 알고 있듯이 미국에서 정오일 때 프랑스에서는 해가 진다. \n프랑스로 단숨에 달려갈 수 만 있다면 해가 지는 광경을 볼 수 있을 것이다.\n 불행히도 프랑스는 너무 멀리 떨어진 곳에 있다. 그러나 너의 조그만 별에서는 의자를 몇 발짝 뒤로 물려 놓기만 하면 되었지.\n 그래서 언제나 원할 때면 너는 석양을 바라볼 수 있었지... \n"어느 날 나는 해가 지는 걸 마흔 세 번이나 보았어!" \n그리고는 잠시 후 너는 다시 말했지. \n"몹시 슬플 때에는 해지는 모습을 좋아하게 되지..." \n"마흔 세 번 본 날 그럼 너는 몹시 슬펐니?" \n그러나 어린 왕자는 대답이 없었다.',
  3: '어쨌든 나는 그의 느닷없는 출현에 너무도 놀라서 눈을 휘둥그렇게 뜨고 그를 바라보았다.\n내가 사람 사는 마을에서 수천 마일 떨어진 곳에 있었다는 사실을 여러분은 잊지 말아 주길 바란다. \n그런데 그 어린아이는 길을 잃은 것 같지도 않아 보였고 피곤과 배고픔과 목마름과 두려움에 시달리는 것 같아 보이지도 않았다.\n 마을에서 수천 마일 떨어진 사막 한가운데에서 길을 잃은 어린아이 같은 구석이라고는 찾아볼 수 없었다. \n가까스로 정신을 차리고 내가 말을 걸었다. "그런데... 왜 그러지?"\n그러자 그는 아주 심각한 이야기나 되는 듯이 소곤소곤 다시 되풀이해 말했다.\n"부탁이야... 양을 한 마리 그려 줘..."\n너무도 인상깊은 신비스러운 일을 당하게 되면 누구나 거기에 순순히 따르게 되기 마련이다. \n마을에서 수천 마일 떨어진 곳에서 죽음의 위험을 마주하고 있는 중에 참 엉뚱한 짓이라고 느껴지기는 했지만 나는 주머니에서 종이 한 장과 만년필을 꺼냈다.',
  4: '언제 구웠는지 더운 김이 홱 끼치는 굵은 감자 세 개가 손에 뿌듯이 쥐였다.\n"느 집엔 이거 없지?"\n하고 생색 있는 큰소리를 하고는 제가 준 것을 남이 알면은 큰일 날테니 여기서 얼른 먹어 버리란다.\n그리고 또 하는 소리가, "너 봄감자가 맛있단다."\n"난 감자 안 먹는다. 너나 먹어라." 나는 고개도 돌리지 않고 일하던 손으로 그 감자를 도로 어깨 너머로 쑥 밀어 버렸다.\n그랬더니 그래도 가는 기색이 없고, 뿐만 아니라 쌔근쌔근하고 심상치 않게 숨소리가 점점 거칠어진다. 이건 또 뭐야 싶어서 그때에야 비로소 돌아다보니 나는 참으로 놀랐다.\n우리가 이 동네에 들어온 것은 근 삼 년째 되어 오지만 여태껏 가무잡잡한 점순이의 얼굴이 이렇게까지 홍당무처럼 새빨개진 법이 없었다.\n그리고 바구니를 다시 집어 들더니 이를 꼭 악물고는 논둑으로 횡하게 달아나는 것이다.',
  5: '나흘 전 감자건만 하더라도 나는 저에게 조금도 잘못한 것은 없다.\n계집애가 나물을 캐러 가면 갔지 남 울타리 엮는 데 쌩이질을 하는 것은 다 뭐냐.\n그것도 발소리를 죽여 가지고 등 뒤로 살며시 와서, "얘! 너 혼자만 일하니?" 하고 긴치 않는 수작을 하는 것이다.\n어제까지도 저와 나는 이야기도 잘 않고 서로 만나도 본척만척하고 이렇게 점잖게 지내던 터이련만 오늘로 갑작스레 대견해졌음은 웬일인가.\n망아지만 한 계집애가 남 일하는 놈 보구….\n"그럼 혼자 하지 떼루 하듸?" 내가 이렇게 내뱉는 소리를 하니까,\n"너 일하기 좋니?" 또는, "한여름이나 되거든 하지 벌써 울타리를 하니?" 잔소리를 두루 늘어놓다가 남이 들을까봐 손으로 입을 틀어막고는 그 속에서 깔깔댄다.\n별로 우스울 것도 없는데 날씨가 풀리더니 이 놈의 계집애가 미쳤나 하고 의심하였다.',
  6: '가까이 와 보니 과연 나의 짐작대로 우리 수탉이 피를 흘리고 거의 빈사지경에 이르렀다.\n닭도 닭이려니와 그러함에도 불구하고 눈 하나 깜짝 없이 고대로 앉아서 호드기만 부는 그 꼴에 더욱 치가 떨린다.\n동네에서도 소문이 났거니와 나도 한때는 걱실걱실히 일 잘 하고 얼굴 예쁜 계집애인 줄 알았더니 시방 보니까 그 눈깔이 꼭 여우 새끼 같다.\n나는 대뜸 달려들어서 나도 모르는 사이에 큰 수탉을 단매로 때려 엎었다.\n닭은 푹 엎어진 채 다리 하나 꼼짝 못 하고 그대로 죽어 버렸다.\n그리고 나는 멍하니 섰다가 점순이가 매섭게 눈을 홉뜨고 닥치는 바람에 뒤로 벌렁 나자빠졌다. "이놈아! 너 왜 남의 닭을 때려죽이니?"\n"그럼 어때?" 하고 일어나다가, "뭐 이 자식아! 누 집 닭인데?" 하고 복장을 떠미는 바람에 다시 벌렁 자빠졌다.\n나는 비슬비슬 일어나며 소맷자락으로 눈을 가리고는, 얼김에 엉 하고 울음을 놓았다.',
  7: '"그럼 너 이담부텀 안 그럴 테냐?"하고 물을 때에야 비로소 살길을 찾은 듯싶었다.\n나는 눈물을 우선 씻고 뭘 안 그러는지 명색도 모르건만,\n"그래!" 하고 무턱대고 대답하였다.\n"요담부터 또 그래 봐라, 내 자꾸 못살게 굴 테니."\n"그래 그래 이젠 안 그럴 테야!"\n"닭 죽은 건 염려 마라, 내 안 이를 테니."\n그리고 뭣에 떠다 밀렸는지 나의 어깨를 짚은 채 그대로 퍽 쓰러진다.\n그 바람에 나의 몸뚱이도 겹쳐서 쓰러지며, 한창 피어 퍼드러진 노란 동백꽃 속으로 폭 파묻혀 버렸다.\n알싸한, 그리고 향긋한 그 냄새에 나는 땅이 꺼지는 듯이 온 정신이 고만 아찔하였다.\n"너 말 마라!" "그래!" 조금 있더니 요 아래서,\n"점순아! 점순아! 이년이 바느질을 하다 말구 어딜 갔어?"\n하고 어딜 갔다 온 듯싶은 그 어머니가 역정이 대단히 났다.\n점순이가 겁을 잔뜩 집어먹고 꽃 밑을 살금살금 기어서 산 아래로 내려간 다음\n나는 바위를 끼고 엉금엉금 기어서 산위로 치빼지 않을 수 없었다.',
};

export const getColorTestContent = (pageNo: number) => {
  return colorTestContents[pageNo];
};

const speedTestContents: Record<number, string> = {
  0: "크루즈 패밀리",
  1: "식품의약품안전처",
  2: "해커스 토익 스피킹 레벨 7, 8",
  3: "경기 남양주시 수동면",
  4: "맥도도 코리아",
  5: "시믹씨엠오코리아",
  6: "도널드 노먼의 디자인 심리학",
  7: "경기 평택시 산단로",
};

export const getSpeedTestContent = (pageNo: number) => {
  return speedTestContents[pageNo];
};
